import $ from 'jquery';
import _ from 'lodash';

export default function(elems, callback = _.noop) {
    let displayed, interval;

    elems = _.isArray(elems) ? elems : [elems];

    function setDisplay(num) {
        if (displayed != num) {
            let str = '000'.substr(String(num).length) + Math.abs(num);

            _.each(elems, (elem) => $(elem).text(num < 0 ? '-' + str : str));

            displayed = num;
            callback(num);
        }
    }

    return function(initialUnbooked) {
        let start = Date.now();
        clearInterval(interval);
        setDisplay(initialUnbooked);

        interval = setInterval(function() {
            setDisplay(Math.floor((Date.now() - start) / 60000 + initialUnbooked));
        }, 1000);
    };
}




/** WEBPACK FOOTER **
 ** ./js/app/common/paulsclock.js
 **/